import { render, staticRenderFns } from "./Odeyr.vue?vue&type=template&id=6a5105fa&scoped=true"
import script from "./Odeyr.vue?vue&type=script&lang=js"
export * from "./Odeyr.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/portfolio.css?vue&type=style&index=0&id=6a5105fa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5105fa",
  null
  
)

export default component.exports